<script setup>
import NativeDateTimeField from '../shared/NativeDateTimeField.vue'
import { utcFieldsInput, utcFieldsFromInput } from '../../dateTime/historyDateTime.js'
import { useI18n } from '../../i18n.js'
defineProps({ model: Object, journal: String, invalid: Boolean })
const { t } = useI18n()
</script>
<template>
  <div class="journal-period-fields">
    <NativeDateTimeField :id="`${journal}-from`" :model-value="utcFieldsInput(model.from)" :label="t('journalFromUtc')" :invalid="invalid" :error-id="`${journal}-filters-error`" @update:model-value="model.from = utcFieldsFromInput($event)" />
    <NativeDateTimeField :id="`${journal}-to`" :model-value="utcFieldsInput(model.to)" :label="t('journalToUtc')" :invalid="invalid" :error-id="`${journal}-filters-error`" @update:model-value="model.to = utcFieldsFromInput($event)" />
  </div>
</template>
